module.exports = __webpack_public_path__ + "icon-desking-lake.c37e0a587355c0aab875.svg";